// src/components/PageLoader.js
import React from 'react';

const PageLoader = () => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh', color: 'white', fontSize: '1.5rem' }}>
      Loading...
    </div>
  );
};

export default PageLoader;